module.exports = fox._r("fonts/ostrich-sans-bold.eot", __webpack_public_path__ + "_/_/_/root/fonts/cKQa2rL.eot");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/ostrich-sans-bold.eot
// module id = 175
// module chunks = 4